import React from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { Typography } from '@material-ui/core';

import { IRangeDivided } from '../../../redux/layers/layerTypes';

type RangeDividedProps = {
  style: IRangeDivided;
};

function RangeDivided({ style }: RangeDividedProps) {
  const classes = useStyles();

  console.log(style);
  return (
    <div className={classes.root}>
      {style.title && (
        <Typography
          className={classes.title}
          color="textPrimary"
          variant="subtitle2">
          {style.title}
        </Typography>
      )}
      <div className={classes.backdrop}>
        <div
          className={classes.rangeBar}
          style={{
            backgroundImage: `linear-gradient(to right, ${style.colors.join(', ')})`,
            gridTemplateColumns: `repeat(${style.labels.length}, ${
              100 / style.labels.length
            }%)`
          }}>
          {style.labels.slice(0, style.labels.length).map((l, i) => (
            <div className={classes.rangeBarDivider} key={i}></div>
          ))}
        </div>
      </div>
      <div
        className={classes.rangeLabels}
        style={{
          gridTemplateColumns: `repeat(${style.labels.length}, ${
            100 / style.labels.length
          }%)`
        }}>
        {style.labels.map((l, i) => (
          <div className={classes.rangeLabel} key={i}>
            {l}
          </div>
        ))}
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      // padding: '0 10px',
      // '&:not(:last-child)': {
      //     marginBottom: 10
      // }
    },
    title: {
      paddingBottom: '5px',
      fontSize: 11
    },
    backdrop: {
      // backgroundColor: '#fff',
      height: '10px',
      width: '100%'
    },
    rangeBar: {
      width: '100%',
      height: '100%',
      display: 'grid',
      justifyContent: 'space-evenly'
    },
    rangeBarDivider: {
      borderLeft: '1px solid #ffffff',
      boxSizing: 'border-box',
      '&:first-child': {
        borderLeft: 'none'
      }
    },
    rangeLabels: {
      display: 'grid',
      justifyContent: 'space-between',
      color: theme.palette.background.contrastText,
      paddingTop: '5px'
    },
    rangeLabel: {
      width: '100%',
      textAlign: 'center',
      fontSize: 10
    }
  })
);

export default RangeDivided;
